export default "__VITE_ASSET__DoMxpFgI__"